import { render, staticRenderFns } from "./client-activity-loader.vue?vue&type=template&id=361b3740"
import script from "./client-activity-loader.vue?vue&type=script&lang=js"
export * from "./client-activity-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports